var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 19,
    viewBox: "0 0 11 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 3.81689C0.5 1.71982 2.26276 0.0200195 4.4375 0.0200195C6.61042 0.0200195 8.375 1.71982 8.375 3.81689V12.1138C8.375 13.513 7.20104 14.645 5.75 14.645C4.29896 14.645 3.125 13.513 3.125 12.1138V5.36377C3.125 4.89619 3.5151 4.52002 4 4.52002C4.4849 4.52002 4.875 4.89619 4.875 5.36377V12.1138C4.875 12.5813 5.2651 12.9575 5.75 12.9575C6.2349 12.9575 6.625 12.5813 6.625 12.1138V3.81689C6.625 2.65182 5.64427 1.70752 4.4375 1.70752C3.23073 1.70752 2.25 2.65182 2.25 3.81689V12.9575C2.25 14.8208 3.7849 16.3325 5.75 16.3325C7.68229 16.3325 9.25 14.8208 9.25 12.9575V5.36377C9.25 4.89619 9.6401 4.52002 10.125 4.52002C10.6099 4.52002 11 4.89619 11 5.36377V12.9575C11 15.7524 8.64844 18.02 5.75 18.02C2.85156 18.02 0.5 15.7524 0.5 12.9575V3.81689Z",
    fill: "#9654FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/Clip.5ff8b69e343f5b2aee8ebcb9efe1bd6f.svg";
export { ForwardRef as ReactComponent };